import { PomodoroTimerMode, PomodoroTimerType } from "@lifeat/shared/widget/PomodoroTimerTypes";
import { AmplitudeEvent } from "@analytics/Amplitude/AmplitudeEvents";

enum WidgetEvent {
    START_POMODORO_TIMER = "start_pomodoro_timer",
    END_POMODORO_TIMER = "end_pomodoro_timer",

    USE_MEDIA_WIDGET = "use_media_widget",

    PLAY_SOUNDBOARD_SOUND = "play_soundboard_sound",

    CREATE_NOTE = "create_note",
    UPDATE_NOTE = "update_note",

    START_BREATHING_EXERCISE = "start_breathing_exercise",
    END_BREATHING_EXERCISE = "end_breathing_exercise",
}

interface PomodoroTimerEventDetails {
    timerType: PomodoroTimerType;
    timerMode: PomodoroTimerMode;
}

export class CreateNoteEvent extends AmplitudeEvent {
    constructor(totalCount: number) {
        super(WidgetEvent.CREATE_NOTE);
        this.props = { totalCount };
    }
}

export class UpdateNoteEvent extends AmplitudeEvent {
    constructor() {
        super(WidgetEvent.UPDATE_NOTE);
    }
}

/**
 * Start pomodoro timer.
 * Note: this event is only triggered when the user starts the pomodoro timer from click
 */
export class StartPomodoroTimerEvent extends AmplitudeEvent {
    constructor(eventDetails: PomodoroTimerEventDetails) {
        super(WidgetEvent.START_POMODORO_TIMER);
        this.props = eventDetails;
    }
}

/**
 * End pomodoro timer.
 * Note: this event is triggered everytime the pomodoro timer ends (including auto-transitions)
 */
export class EndPomodoroTimerEvent extends AmplitudeEvent {
    constructor(eventDetails: PomodoroTimerEventDetails) {
        super(WidgetEvent.END_POMODORO_TIMER);
        this.props = eventDetails;
    }
}

export class UseMediaWidgetEvent extends AmplitudeEvent {
    constructor() {
        super(WidgetEvent.USE_MEDIA_WIDGET);
    }
}

export class AmbientSoundboardPlayEvent extends AmplitudeEvent {
    constructor(soundName: string) {
        super(WidgetEvent.PLAY_SOUNDBOARD_SOUND);
        this.props = { soundName: soundName };
    }
}

export class StartBreathingExerciseEvent extends AmplitudeEvent {
    constructor() {
        super(WidgetEvent.START_BREATHING_EXERCISE);
    }
}

export class EndBreathingExerciseEvent extends AmplitudeEvent {
    constructor() {
        super(WidgetEvent.END_BREATHING_EXERCISE);
    }
}
